import React from 'react';

import './css/styles.css';

class CardLaUnidadEquipo extends React.Component{
    render(){

        //let image = require('../img/avatar-'+this.props.index+'.png');

        return(
            <div className="card transparent z-depth-0">
                <div className="card-image">
                    <img src={this.props.imagen} alt="imagen"/>
                </div>
                <div className="card-content">
                    <NombreIntegrante text={this.props.nombre}/>
                    <p className={`custom-fontText`}>{this.props.funcion}</p>
                </div>
            </div>
        );
    }
}

class NombreIntegrante extends React.Component{
    render(){
        return(
            <div className="row">
                <p className="equipo_nombre_integrante">{this.props.text}</p>
            </div>
        );
    }
}

export default CardLaUnidadEquipo;